"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactColor = require("react-color"),
    _colorPicker = require("../styles/colorPicker"),
    _Input = _interopRequireDefault(require("../../Input")),
    _Button = _interopRequireDefault(require("../../Button"));

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var ColorPicker = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.handleColorChange = function (a) {
      var b = a.hex,
          c = d.props,
          e = c.onSaveColor,
          f = c.colourOnly,
          g = c.withHash,
          h = b.substring(1, b.length);
      d.setState({
        hex: h
      }), f && e({
        hex: g ? b : h
      });
    }, d.handleLabelChange = function (a) {
      var b = a.target.value;
      d.setState({
        label: b
      });
    }, d.handleColorSave = function () {
      var a = d.props,
          b = a.onSaveColor,
          c = a.withHash,
          e = d.state,
          f = e.hex,
          g = e.label;
      b({
        hex: c ? "#".concat(f) : f,
        label: g
      });
    }, d.state = {
      hex: a.initialValue.hex,
      label: a.initialValue.label
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.state,
          b = a.hex,
          c = a.label,
          d = this.props.colourOnly;
      return d ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])("color-picker", _colorPicker.WRAPPER)
      }, _react["default"].createElement(_reactColor.SketchPicker, {
        disableAlpha: !0,
        color: b,
        onChangeComplete: this.handleColorChange
      })) : _react["default"].createElement("div", {
        className: (0, _classnames["default"])("color-picker", _colorPicker.WRAPPER)
      }, _react["default"].createElement(_reactColor.SketchPicker, {
        disableAlpha: !0,
        color: b,
        onChangeComplete: this.handleColorChange
      }), _react["default"].createElement("hr", null), _react["default"].createElement("div", {
        className: (0, _classnames["default"])("color-picker__content", _colorPicker.CONTENT)
      }, _react["default"].createElement(_Input["default"], {
        label: "Color Name",
        defaultValue: c,
        className: (0, _classnames["default"])("color-picker__name-input", _colorPicker.NAME_INPUT),
        placeholder: "Color Name",
        onChange: this.handleLabelChange
      }), _react["default"].createElement(_Button["default"], {
        className: (0, _classnames["default"])("color-picker__name-button", _colorPicker.SAVE_BUTTON),
        onClick: this.handleColorSave,
        small: !0
      }, "SAVE CHANGES")));
    }
  }]), b;
}(_react.Component);

ColorPicker.defaultProps = {
  initialValue: {
    hex: "000000",
    label: ""
  }
};
var _default = ColorPicker;
exports["default"] = _default;